import { YAMLException, load as loadYaml } from "js-yaml"
import * as yup from "yup"
import { ValidationError } from "@utils/form"

export const validationSchema = yup.object().shape({
  configuration: yup
    .string()
    .required(ValidationError.REQUIRED)
    .test("is-valid-yaml-format", (value, { createError, path }) => {
      try {
        loadYaml(value)
      } catch (error) {
        return createError({ path, message: (error as YAMLException).message })
      }

      return true
    }),
})
